import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import ATabs from '@/components/atoms/ATabs.vue'
	import MDynamicForm from '@/components/molecules/MDynamicForm.vue'
	import MOptionalsForm from '@/components/molecules/MOptionalsForm.vue'
	import MDocumentation from '@/components/molecules/MDocumentation.vue'

	import type { ObjectContext } from '@/global'
	import type { ComputedRef } from 'vue'

	import { ref, reactive, computed, watch } from 'vue'
	import { useGeneral } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  props: {
		item: { type: Object, default: null, required: true }
	},
  setup(__props) {

const $props = __props

	const { $t, $moment, $store, $router, $route, goToMainView, isNew, isCopy, tabSelected, mainClick, loading, dictionary } = useGeneral()

	

	const state = reactive({
		tab: 'information',
		item: {},
		optionals: [],
		optionalsToDelete: []
	})

	const formTitleKey: ComputedRef<string> = computed(() => $store.getters['forms/GET_FORM_TITLE_KEYS'][tabSelected.value] || 'General_title')
	// @ts-ignore
	const titleValue = computed(() => state.item[formTitleKey.value])
	function updateTitle() {
		$store.dispatch('forms/setFormTitle', titleValue.value || '')
	}
	watch(
		() => titleValue.value,
		() => updateTitle()
	)

	const tabItems: ComputedRef = computed(() => {
		const items = [{ text: 'General_information', value: 'information', disabled: false }]
		if (tabSelected.value === 'persons') {
			items.push({ text: 'PersonsDialog_tab_history', value: 'history', disabled: isNew.value })
		}
		if (['persons', 'customers', 'warehouses'].includes(tabSelected.value)) {
			items.push({ text: 'General_documentation', value: 'documents', disabled: isNew.value })
		}
		return items
	})

	function changeTab(event: string) {
		state.tab = event
	}

	const invisibleKeys: ComputedRef = computed(() => Object.values($store.getters['dictionary/GET_INVISIBLE'][tabSelected.value] || {}))
	const requiredKeys: ComputedRef = computed(() => Object.values($store.getters['dictionary/GET_REQUIRED'][tabSelected.value] || {}))
	const formHiddenKeys: ComputedRef = computed(() => Object.values($store.getters['dictionary/GET_FORM_HIDDEN'][tabSelected.value] || {}))
	const datetimeKeys: ComputedRef = computed(() => Object.values($store.getters['dictionary/GET_DATETIME'][tabSelected.value] || {}))

	const sections: ComputedRef = computed(() => {
		const inputs = {
			information: [
				{ id: 'required_information', title: 'Form_step_required', keys: requiredKeys.value }
				// { id: 'optional_information', title: 'Form_step_optional', keys: [] }
			]
		}
		// @ts-ignore
		return inputs[state.tab] || []
	})

	function deleteKey(key: string) {
		// @ts-ignore
		if (key && !state.optionalsToDelete.includes(key)) state.optionalsToDelete.push(key)
	}
	function updateOptionals(items: Array<ObjectContext>) {
		state.optionals = JSON.parse(JSON.stringify(items))
	}

	watch(
		() => $props.item,
		(val: any) => {
			const item = Object.assign({}, val || {})
			const keys = invisibleKeys.value.concat(requiredKeys.value).concat(formHiddenKeys.value)
			keys.forEach((key: string) => {
				// @ts-ignore
				state.item[key] = val[key]
				delete item[key]
			})
			const optionals = Object.keys(item).map(key => {
				return { key, value: item[key] }
			})
			// @ts-ignore
			state.optionals = optionals
		}
	)

	const itemIdKey = computed(() => $store.getters['GET_ITEM_ID_KEY'][tabSelected.value] || '')

	const refForm = ref(null)

	async function onSaveItem() {
		const action = isNew.value || isCopy.value ? 'create' : 'update'
		const tab = tabSelected.value
		if (state.tab !== 'information') {
			$store.dispatch('alert/SET_ALERT', { action, color: 'success' })
			goToMainView()
		} else {
			// @ts-ignore
			const res = await refForm.value.validate()
			let isValid = res.valid
			requiredKeys.value.forEach((key: string) => {
				const dictionaryElement = dictionary.value[key]
				if (dictionaryElement.type === 'list') {
					// @ts-ignore
					if (!Array.isArray(state.item[key])) isValid = false
					// @ts-ignore
					else if (!state.item[key].length) isValid = false
				}
			})
			if (!isValid) $store.dispatch('alert/SET_ALERT', { text: $t('Form_missing_required') })
			else {
				loading.value = true
				try {
					const hiddenKeys = invisibleKeys.value.concat(formHiddenKeys.value)

					const item = Object.assign({}, state.item)
					let body = {}
					const tempBody = {}
					// @ts-ignore
					state.optionalsToDelete.forEach(key => (item[key] = null))
					// @ts-ignore
					state.optionals.forEach(e => (item[e.key] = e.value))
					Object.keys(item).forEach(key => {
						// @ts-ignore
						if (!hiddenKeys.includes(key)) {
							// @ts-ignore
							if (!datetimeKeys.value.includes(key)) tempBody[key] = item[key]
							else {
								// @ts-ignore
								tempBody[key] = $moment(item[key]).format()
							}
						}
					})
					if (isNew.value) body = Object.assign({}, tempBody)
					else {
						// @ts-ignore
						body._item = tempBody
						// @ts-ignore
						body[itemIdKey.value] = $props.item[itemIdKey.value]
					}
					const res = await $store.dispatch(`${tab}/${action}`, body)
					$store.dispatch('alert/SET_ALERT', { action, color: 'success' })
					if (tabSelected.value !== 'persons') goToMainView()
					else {
						const data = res.data.response_json
						const routeName = $route.name.replace('_create', '_edit')
						$router.replace({
							name: routeName,
							params: {
								tab: tabSelected.value,
								id: data.person_id
							}
						})
					}
				} catch (error) {
					console.log(`🚀 ~ onSaveItem ~ error`, error)
					$store.dispatch('alert/SET_ALERT', { action, error })
				} finally {
					loading.value = false
				}
			}
		}
	}

	watch(mainClick, () => onSaveItem())

	function init() {
		$store.dispatch('forms/initSteps', { tabSelected: tabSelected.value })
	}
	init()

return (_ctx: any,_cache: any) => {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "mt-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        class: "mb-7"
      }, {
        default: _withCtx(() => [
          (_unref(loading))
            ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                key: 0,
                type: "text"
              }))
            : (_openBlock(), _createBlock(ATabs, {
                key: 1,
                modelValue: _unref(state).tab,
                items: _unref(tabItems),
                onChange: _cache[0] || (_cache[0] = ($event: any) => (changeTab($event)))
              }, null, 8, ["modelValue", "items"]))
        ]),
        _: 1
      }),
      (_unref(state).tab === 'documents')
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(MDocumentation, {
                item: $props.item,
                "tab-selected": _unref(tabSelected)
              }, null, 8, ["item", "tab-selected"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_form, {
            key: 1,
            ref_key: "refForm",
            ref: refForm
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sections), (section) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: section.id
                }, [
                  (section.id === 'optional_information' ? _unref(state).optionals.length : section.title)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "12"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref($t)(section.title)) + " ", 1),
                          _createVNode(_component_v_divider, {
                            color: "primary_alt",
                            class: "mt-4"
                          })
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      (section.id === 'optional_information')
                        ? (_openBlock(), _createBlock(MOptionalsForm, {
                            key: 0,
                            modelValue: _unref(state).optionals,
                            "tab-selected": _unref(tabSelected),
                            item: _unref(state).item,
                            onDeleteKey: _cache[1] || (_cache[1] = ($event: any) => (deleteKey($event))),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (updateOptionals($event)))
                          }, null, 8, ["modelValue", "tab-selected", "item"]))
                        : (_openBlock(), _createBlock(MDynamicForm, {
                            key: 1,
                            modelValue: _unref(state).item,
                            table: section.table,
                            keys: section.keys,
                            "tab-selected": _unref(tabSelected)
                          }, null, 8, ["modelValue", "table", "keys", "tab-selected"]))
                    ]),
                    _: 2
                  }, 1024)
                ], 64))
              }), 128))
            ]),
            _: 1
          }, 512))
    ]),
    _: 1
  }))
}
}

})